import React from 'react'
import { BulkExportButton, Exporter } from 'react-admin'
import exportFormatter from 'services/csv/exporter'

type Props = {
  selectedIds?: number[]
}
const BulkExportButtonWrapper: React.FC<Props> = ({
  selectedIds = [],
  ...rest
}) => {
  return (
    <BulkExportButton
      {...rest}
      selectedIds={selectedIds}
      exporter={exportFormatter(true) as Exporter}
    />
  )
}
export default BulkExportButtonWrapper
